<template>
	<app>
		<crumb-bar :current="detailInfo.name"></crumb-bar>
		<module>
			<flow-node :node="nodeList" :current="currentNode" :reject="rejectNode"></flow-node>
			<c-title>项目详情</c-title>
			<c-detail>
				<c-detail-item label="项目名称">
					{{detailInfo.name}}
				</c-detail-item>
				<c-detail-item label="项目状态">
					<span v-if="projectState[detailInfo.state]" :style="{'color': projectState[detailInfo.state].color}">{{projectState[detailInfo.state].name}}</span>
				</c-detail-item>
				<c-detail-item label="项目编号">
					{{detailInfo.code}}
				</c-detail-item>
				<c-detail-item label="业主单位">
					{{detailInfo.yzdw_name}}
				</c-detail-item>
				<c-detail-item label="项目所属行业">
					{{detailInfo.sshy}}
				</c-detail-item>
				<c-detail-item label="业主单位地址">
					{{detailInfo.yzdw_address}}
				</c-detail-item>
				<c-detail-item label="建设地址">
					{{detailInfo.xm_address}}
				</c-detail-item>
				<c-detail-item label="业主单位联系人">
					{{detailInfo.yzdw_lxr}}<span v-if="detailInfo.yzdw_lxdh">（{{detailInfo.yzdw_lxdh}}）</span>
				</c-detail-item>
				<c-detail-item label="招标文件">
					<c-file :src="detailInfo.files_path"></c-file>
				</c-detail-item>
				<c-detail-item label="组织部门">
					{{detailInfo.yzdw_organization_name}}
				</c-detail-item>
				<c-detail-item label="招标代理费付款方">
					{{detailInfo.zbdl_money_user_type == 1 ? '企业' : '业主'}}
				</c-detail-item>
				<c-detail-item label="被保险人">
					{{detailInfo.bbxr_name}}
				</c-detail-item>
				<c-detail-item label="备注说明">
					{{detailInfo.remark}}
				</c-detail-item>
				<c-detail-item label="被保险人组织代码">
					{{detailInfo.bbxr_jgdm}}
				</c-detail-item>
			</c-detail>
			
			<c-title v-if="detailInfo.state == 4">中标企业信息</c-title>
			<c-detail v-if="detailInfo.state == 4">
				<c-detail-item label="工期">
					<span v-if="detailInfo.sggq">{{detailInfo.sggq}}天</span>
				</c-detail-item>
				<c-detail-item label="中标单位">
					{{detailInfo.zbqy_name}}
				</c-detail-item>
				<c-detail-item label="中标金额">
					{{detailInfo.zb_money}}
				</c-detail-item>
				<c-detail-item label="中标单位地址">
					{{detailInfo.zbqy_address}}
				</c-detail-item>
				<c-detail-item label="中标通知书">
					<c-file :src="detailInfo.zb_path"></c-file>
				</c-detail-item>
				<c-detail-item label="中标企业法人">
					{{detailInfo.zbqy_user_realname}}
				</c-detail-item>
				<c-detail-item label="项目经理">
					{{detailInfo.xmjl_xm}}<span v-if="detailInfo.xmjl_lxdh">（{{detailInfo.xmjl_lxdh}}）</span>
				</c-detail-item>
				<c-detail-item label="中标企业联系电话">
					{{detailInfo.zbqy_user_phone}}
				</c-detail-item>
				<c-detail-item label="技术总工">
					{{detailInfo.jszg_xm}}<span v-if="detailInfo.jszg_lxdh">（{{detailInfo.jszg_lxdh}}）</span>
				</c-detail-item>
				<c-detail-item label="监理单位">
					{{detailInfo.jldw_name}}
				</c-detail-item>
				<c-detail-item label="安全员">
					{{detailInfo.aqy_xm}}<span v-if="detailInfo.aqy_lxdh">（{{detailInfo.aqy_lxdh}}）</span>
				</c-detail-item>
				<c-detail-item label="监理单位地址">
					{{detailInfo.jldw_address}}
				</c-detail-item>
				<c-detail-item label="施工员">
					{{detailInfo.sgy_xm}}<span v-if="detailInfo.sgy_lxdh">（{{detailInfo.sgy_lxdh}}）</span>
				</c-detail-item>
				<c-detail-item label="企业需购买保函">
					<b style="color: #E63633;">{{insurance}}</b>
				</c-detail-item>
				<c-detail-item label="质检员">
					{{detailInfo.zjy_xm}}<span v-if="detailInfo.zjy_lxdh">（{{detailInfo.zjy_lxdh}}）</span>
				</c-detail-item>
				<c-detail-item label="项目签约截止日">
					{{detailInfo.qy_last_date}}
				</c-detail-item>
				<c-detail-item label="备注说明" full>
					{{detailInfo.zb_remark}}
				</c-detail-item>
			</c-detail>
			
			<c-title v-if="detailInfo.state == 4">项目关联保函</c-title>
			<project-insurance v-if="detailInfo.state == 4" :project-id="id" :data="insuranceList"></project-insurance>
			
			<c-title>创建流程</c-title>
			<c-detail>
				<c-detail-item label="创建流程" full>
					<timeline :data="timeline"></timeline>
				</c-detail-item>
			</c-detail>
			
			<c-button v-if="biddingButton" slot="button" size="m" width="300" @click="$refs.bidding.open(detailInfo.id)">设置中标企业</c-button>
			<c-button v-if="personButton" slot="button" size="m" width="300" @click="$refs.person.open(detailInfo.id)">设置项目人员</c-button>
		</module>
		
		<bidding-company v-if="biddingButton" ref="bidding" @resolve="updateDetail"></bidding-company>
		<install-person v-if="personButton" ref="person" @resolve="updateDetail"></install-person>
	</app>
</template>

<script>
	import flowNode from '@/components/module/flow_node.vue'
	import projectInsurance from '@/pages/insurance/project_insurance.vue'
	import timeline from '@/components/module/timeline.vue'
	import biddingCompany from './bidding_company.vue'
	import installPerson from './install_person.vue'
	import {mapGetters} from 'vuex'
	
	export default {
		components: {
			flowNode,
			projectInsurance,
			timeline,
			biddingCompany,
			installPerson
		},
		
		props: {
			id: String
		},
		
		data() {
			return {
				nodeList: [{
					name: '创建项目'
				}, {
					name: '(业主单位)确认'
				}, {
					name: '设置中标企业'
				}, {
					name: '创建成功'
				}],
				detailInfo: {},
				insurance: '',
				insuranceList: [],
				timeline: ''
			}
		},
		
		computed: {
			...mapGetters(['power', 'projectState', 'insuranceState']),
			
			currentNode() {
				return [31, 32].includes(this.detailInfo.state) ? 3 : this.detailInfo.state;
			},
			
			rejectNode() {
				return this.detailInfo.state == 1 ? 2 : 0;
			},
			
			biddingButton() {
				return this.detailInfo.state == 3 && this.power('5');
			},
			
			personButton() {
				return this.detailInfo.jldw_name && this.detailInfo.set_ry_count == 0 && this.power('7');
			}
		},
		
		mounted() {
			this.updateDetail();
		},
		
		methods: {
			updateDetail() {
				this.request({
					url: '/project/detail',
					data: {
						project_id: this.id
					},
					success: data => {
						this.detailInfo = data.project_info;
						this.insurance = Array.from(data.bx_list, item => {
							return item.bx_type_name;
						}).join('，');
						this.insuranceList = data.bx_list;
						this.timeline = Array.from(data.logList, item => {
							return {
								date: item.create_date,
								content: `[${item.create_user_name}] ${item.remark}`
							}
						});
					}
				});
			}
		}
	}
</script>

<style lang="stylus" scoped>
</style>
